module.exports = __webpack_public_path__ + "static/media/feature_1.d605bbae.jpg";